import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Item = styled.li`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 6px 24px;
  align-items: center;
  border-radius: 8px;
  &:hover {
    background: ${themeGet('colors.primary.10')};
  }

  &:last-child {
    margin-bottom: 20px;
  }
`;

export const IconContainer = styled.div`
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-right: 5px;
  &:hover {
    color: ${themeGet('colors.primary.100')};
    border: 1px solid ${themeGet('colors.primary.100')};
    cursor: pointer;
  }
`;

export const ColorDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${props => props.color};
  display: inline-block;
  margin-right: 8px;
`;

export const Name = styled.div``;
